/**
 * Frontend configuration that differs per environment.
 *
 * The image is environment-agnostic: `docker/Dockerfile` builds it with every
 * VITE_* variable set to its own placeholder (`ENV_VITE_API_URL`), and
 * `docker/entrypoint.sh` substitutes the real values into dist/ when the
 * container starts. One build is deployed to every environment.
 *
 * Read through `env(key)` rather than `import.meta.env.VITE_X` directly: Vite
 * constant-folds the direct form and then dead-code-eliminates whatever depends
 * on it, which would strip the placeholders out of the bundle before the
 * entrypoint ever sees them. The dynamic key forces Vite to emit the whole
 * import.meta.env object, so the placeholders survive as real runtime strings.
 *
 * To add a variable: declare it in `docker/Dockerfile`, export it here, and put
 * it in the chart's `envs` map. The entrypoint needs no change.
 */
function env(key: string): string | undefined {
	const value = (import.meta.env as Record<string, string | undefined>)[key];
	return value === "" ? undefined : value;
}

/** Backend API root, including the /api prefix. */
export const API_URL = /* @__PURE__ */ env("VITE_API_URL");

/** This app's own public origin, used to build links back into it. */
export const BASE_URL = /* @__PURE__ */ env("VITE_BASE_URL");

/**
 * True on the self-service deployment: the business app (sign-up, setup wizard) is the root and
 * the dashboard moves under /admin - see lib/platform. Anything else is the enterprise app.
 * Compared as text because the entrypoint substitutes a string, and "false" is truthy.
 */
export const SMB_PLATFORM = /* @__PURE__ */ env("VITE_SMB_PLATFORM") === "true";
